<div id="ct-parameter-heading" class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Parametrierung Kennlinien"}}: {{circuit.attributes.name}}{{#if circuit.attributes.mode}} ({{circuit.attributes.mode}}){{/if}}</h4>
</div>
<div class="modal-body">
	<div class="gc-2-3">
		<label>{{TR "Kennlinientyp wählen"}}</label>
		<select name="parameter_mode" class="selectpicker js-parameter-type" data-style="btn-white btn-sm">
			{{#each types}}
			<option value="{{@key}}" {{#COMPARE @key '==' ../graphType}}selected="selected"{{/COMPARE}}>{{name}}</option>
			{{/each}}
		</select>
	</div>
	{{#if showWarning}}
	<div class="alert alert-warning m-t-10">
		{{TR "Die Aktivierung/Deaktivierung der Festwertregelung wird auf alle Heizkreise des Reglers übertragen."}}
	</div>
	{{/if}}
	<div id="js-parameter-region"></div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal"> {{TR "Abbrechen"}} </button>
	</button><button id="js-save" class="btn btn-primary">{{TR "Speichern"}}</button>
</div>
